/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import { dateOnlyToQuery } from './DateOnly';
import type {
  ProblemDetails,
  SeizableIncomeCalculationResponse,
  SeizableIncomePeriodResponse,
  ValidationProblemDetails,
} from '../models/index';
import {
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    SeizableIncomeCalculationResponseFromJSON,
    SeizableIncomeCalculationResponseToJSON,
    SeizableIncomePeriodResponseFromJSON,
    SeizableIncomePeriodResponseToJSON,
    ValidationProblemDetailsFromJSON,
    ValidationProblemDetailsToJSON,
} from '../models/index';

export interface CalculateSeizableIncomeRequest {
    monthlyIncome?: number;
    asOf?: Date;
    maintenanceObligationCount?: number;
    maintenanceSeizureCount?: number;
    hasSpecialPayments?: boolean;
    isMaintenanceSeizure?: boolean;
}

/**
 * SeizableIncomeCalculationApi - interface
 * 
 * @export
 * @interface SeizableIncomeCalculationApiInterface
 */
export interface SeizableIncomeCalculationApiInterface {
    /**
     * 
     * @param {number} [monthlyIncome] 
     * @param {Date} [asOf] 
     * @param {number} [maintenanceObligationCount] 
     * @param {number} [maintenanceSeizureCount] 
     * @param {boolean} [hasSpecialPayments] 
     * @param {boolean} [isMaintenanceSeizure] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeizableIncomeCalculationApiInterface
     */
    calculateSeizableIncomeRaw(requestParameters: CalculateSeizableIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeizableIncomeCalculationResponse>>;

    /**
     */
    calculateSeizableIncome(requestParameters: CalculateSeizableIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeizableIncomeCalculationResponse>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SeizableIncomeCalculationApiInterface
     */
    getSeizableIncomePeriodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SeizableIncomePeriodResponse>>>;

    /**
     */
    getSeizableIncomePeriods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SeizableIncomePeriodResponse>>;

}

/**
 * 
 */
export class SeizableIncomeCalculationApi extends runtime.BaseAPI implements SeizableIncomeCalculationApiInterface {

    /**
     */
    async calculateSeizableIncomeRaw(requestParameters: CalculateSeizableIncomeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SeizableIncomeCalculationResponse>> {
        const queryParameters: any = {};

        if (requestParameters['monthlyIncome'] != null) {
            queryParameters['MonthlyIncome'] = requestParameters['monthlyIncome'];
        }

        if (requestParameters['asOf'] != null) {
            queryParameters['AsOf'] = dateOnlyToQuery(requestParameters['asOf'] as Date);
        }

        if (requestParameters['maintenanceObligationCount'] != null) {
            queryParameters['MaintenanceObligationCount'] = requestParameters['maintenanceObligationCount'];
        }

        if (requestParameters['maintenanceSeizureCount'] != null) {
            queryParameters['MaintenanceSeizureCount'] = requestParameters['maintenanceSeizureCount'];
        }

        if (requestParameters['hasSpecialPayments'] != null) {
            queryParameters['HasSpecialPayments'] = requestParameters['hasSpecialPayments'];
        }

        if (requestParameters['isMaintenanceSeizure'] != null) {
            queryParameters['IsMaintenanceSeizure'] = requestParameters['isMaintenanceSeizure'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/seizable-income`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SeizableIncomeCalculationResponseFromJSON(jsonValue));
    }

    /**
     */
    async calculateSeizableIncome(requestParameters: CalculateSeizableIncomeRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SeizableIncomeCalculationResponse> {
        const response = await this.calculateSeizableIncomeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getSeizableIncomePeriodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<SeizableIncomePeriodResponse>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/seizable-income/periods`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SeizableIncomePeriodResponseFromJSON));
    }

    /**
     */
    async getSeizableIncomePeriods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<SeizableIncomePeriodResponse>> {
        const response = await this.getSeizableIncomePeriodsRaw(initOverrides);
        return await response.value();
    }

}
